<template>
    <f7-page
        name="Subscribe Start"
        no-navbar
    >
        <div style="position: relative">
            <div style="position: absolute; left: 16px; top: 0">
                <f7-link
                    v-if="isPgap"
                    style="color: #808080; padding: 10px; line-height: 34px; font-size: 15px; letter-spacing: -.3px"
                    @click="restorePurchases"
                >RESTORE PURCHASES
                </f7-link>
            </div>
            <div style="position: absolute; right: 16px; top: 0">
                <transition
                    v-if="showSkip"
                    name="fade"
                >
                    <f7-link
                        :href="`#`"
                        style="color: #808080; padding: 10px; font-weight: bold; line-height: 34px; font-size: 15px"
                        @click="trackSkip"
                    >
                        {{ closeIsBack ? 'SKIP' : 'X' }}
                    </f7-link>
                </transition>
            </div>
        </div>
        <br>
        <div v-if="isAndroid">
            <p class="safe-area-top" />
            <h1 class="Stitle">Say yes</h1>
            <h3 class="Ssubtitle">to better sex</h3>
            <p
                class="imgContainer"
                style="position: relative"
            >
                <img
                    src="../../img/0.4/subscribe.png"
                    class="img"
                >
            </p>

            <f7-block class="arguments">
                <i class="icon ion-ios-checkmark" /> <br>Unlimited access to personalized content<br style="clear: both">
                <i class="icon ion-ios-checkmark" /> <br>Hundreds of stories, exercises and lessons<br style="clear: both">
                <i class="icon ion-ios-checkmark" /> <br>
                <div
                    v-if="isRelationship"
                    style="line-height: 18px; margin-top: -8px"
                >Your partner gets full access for free as long as you're subscribed</div>
                <span v-else>New content added weekly</span>
            </f7-block>
            <div class="bordered-around">
                <div class="bordered">
                    <div class="bordered-inner">
                        <f7-block class="f7-block">
                            <p class="startCopy">Start with 7 days free</p>
                            <p style="margin-top: 1.5em;"/>
                            <f7-button
                                style="letter-spacing: -0.1px; text-transform: none; width: 100%; padding-left: 2em; padding-right: 2em; margin-top: 0em; margin-bottom: 0.7em;"
                                color="red"
                                fill
                                large
                                round
                                @click="purchase()"
                            >&nbsp;TRY CORAL FOR FREE&nbsp;</f7-button>
                            <p class="price-string"> {{ product.priceString || '$59.99' }}/year billed at trial end</p>
                        </f7-block>
                    </div>
                </div>
            </div>
        </div>

        <!-- DEFAULT / iOS VIEW -->
        <div
            v-else
            class="ios-default-container">

            <p class="safe-area-top" />
            <div class="ios-image-container">
                <div class="ios-free-trial-btn">
                    <span>First 7 days free</span>
                </div>
                <div class="ios-imgContainer">
                    <img
                        src="../../img/0.4/subscribe.png"
                        class="ios-img"
                    >
                </div>
            </div>

            <f7-block class="container">
                <h2 class="ios-Stitle">
                    <span>Unlock Better Sex</span>
                    <br>
                    <span>for Free</span>
                </h2>

                <f7-block class="ios-arguments">
                    <div class="argument">
                        <i class="icon ion-ios-checkmark" /> <br><span>Personalize your journey with our new goal-based learning</span><br style="clear: both">
                    </div>
                    <div class="argument">
                        <i class="icon ion-ios-checkmark" /> <br><span>Add your partner for free and explore together</span><br style="clear: both">
                    </div>
                    <div class="argument">
                        <i class="icon ion-ios-checkmark" /> <br><span>Discuss with experts to answer specific questions</span><br style="clear: both">
                    </div>
                    <div class="argument">
                        <i class="icon ion-ios-checkmark" /> <br><span>Discover audio exercises to heat things up</span><br style="clear: both">
                    </div>
                </f7-block>
                <f7-block class="ios-start-free-container">
                    <p class="ios-product-string">
                        {{ product.priceString || '$59.99' }} Annually
                        <br>
                        <span>
                            First 7 days free
                        </span>
                    </p>
                    <div class="ios-add-partner-container">
                        <p class="ios-add-partner">ADD PARTNER FOR FREE</p>
                    </div>
                </f7-block>
                <div class="bordered-around">
                    <f7-block class="ios-f7-block-button-container">
                        <f7-button
                            class="ios-f7-button"
                            color="red"
                            fill
                            large
                            round
                            @click="purchase()"
                        >&nbsp;Try free and subscribe&nbsp;</f7-button>
                    </f7-block>
                </div>
            </f7-block>
        </div>
        <div class="ios-bottom-tray">
            <f7-link
                href="/subscribeTerms"
                class="ios-minorActions"
            >
                Renewal details
            </f7-link>
            <p class="ios-minorActions">&nbsp;| Cancel Anytime</p>
        </div>
    </f7-page>
</template>

<script>
export default {
    store: ['api', 'user', 'products', 'myTraits'],
    data () {
        return {
            variant: 0,
            showSkip: false,
            closeIsBack: true,
            redirectUrl: '/home',
            product: {
                priceString: '',
                price: 59.99
            },
        };
    },
    computed: {
        isPgap: function () {
            return pgap;
        },
        isAndroid: function () {
            try {
                return device.platform === 'Android';
            } catch (e) {
                return false;
            }
        },
        getBranch: function () {
            return localStore.getItem('branch') || 'production';
        },
        isRelationship: function () {
            let is = true;
            for (let i = 0; i < this.myTraits.length; i++) {
                const e = this.myTraits[i];
                if (e === 14) is = false;
            }
            return is;
        },
    },
    created: function () {
        this.variant = parseFloat(window.localStore.getItem(`experiment-014_goals`));
        this.$events.fire('trackEvent', `subscription_offer_presented`, '001');
        this.$events.fire('subscriptions-sync', () => {
            this.$events.fire('get-product-from-sku', 'SKU02', (product) => {
                this.product = product;
                console.log(this.product)
            });
        });
        if (this.$f7route.query.goToHome) {
            this.closeIsBack = false;
        }
        if (this.$f7route.query.redirect) {
            this.redirectUrl = this.$f7route.query.redirect;
        }
    },
    mounted: function () {
        this.showSkip = true;
    },
    methods: {
        trackSkip: function () {
            setTimeout(() => { // mitigate glitch... maybe
                this.$events.fire('trackEvent', 'subscription_skipped', 'subscription', 0, '');
            }, 1000);
            if (this.closeIsBack) {
                if (f7.views['main'].router.history.length === 1) {
                    return f7.views['main'].router.navigate('/home', { clearPreviousHistory: true, transition: 'f7-fade', });
                }
                return f7.views['main'].router.back();
            } else {
                f7.views['main'].router.navigate(([1, 3].indexOf(this.variant) > -1 ? '/onboarding/goals' : '/home'), {
                    transition: 'f7-fade',
                    clearPreviousHistory: true
                });
            }
        },
        purchase: function () {
            this.$events.fire('subscriptions-purchase', this.product, this.redirectUrl);
        },
        restorePurchases: function () {
            this.$events.fire('subscriptions-restore');
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';
.ios-default-container {
    max-width: 400px;
    margin: 0 auto;
    .block {
        margin: 0;
    }
    .ios-start-free-container {
        padding-bottom: 0.3em;
        padding-top: 0.3em;
        margin: 1.5em 0;
    }
}
.ios-image-container {
    position: relative;
    width: 100%;
}
#skipBtn {
    font-size: 20px;
    padding: 10px;
    color: @black;
}
.Stitle {
    padding-top: ~'calc(var(--f7-appbar-app-offset) + 44px)';
    text-align: center;
    margin: 30px 0 0;
    color: @black;
}
.ios-Stitle {
    padding-top: ~'calc(var(--f7-appbar-app-offset) + 44px)';
    margin: 16px auto 0.5em;
    padding-left: 8px;
    text-align: center;
    padding-bottom: 0;
    color: @black;
    font-size: 36px;
    span {
        margin-bottom: 0.1em;
        line-height: 1.2em;
    }
}
.Ssubtitle {
    margin-top: 0;
    text-align: center;
    font-family: Editor-Bold;
    color: @black;
}
.theme-dark {
    .Stitle {
        color: #fff;
    }
    .Ssubtitle {
        color: #fff;
    }
    .ios-Stitle {
        color: white;
    }
    #skipBtn {
        color: #fff;
    }
}
.imgContainer, .ios-imgContainer {
    text-align: center;
    padding: 0 0 1em 0;
    margin: 0;
    position: relative;
}
.img {
    height: 180px;
}
.ios-img {
    height: 100px;
}
.ios-start-free-container {
    display: flex;
    justify-content: space-between;
    background: @darkBlue;
    border-radius: 0.5em;
    margin-bottom: 2em;
    margin-top: 2em;
    p {
        margin: 0;
    }
}
.ios-add-partner-container {
    border-radius: 0.5em;
    background: @linkButtonOrange;
    margin: 0.3em;
    width: 20%;
    flex-grow: 1;
    .ios-add-partner {
        color: white;
        font-size: 12px;
        font-weight: bolder;
        padding: 5px;
    }
}
.ios-product-string {
    align-self: center;
    color: white;
    flex-grow: 4;
    font-weight: bold;
    line-height: 1.5em;
    padding-right: 4em;
    text-align: left;
    width: 50%;
    span {
        font-weight: normal;
        line-height: 1em;
        margin-top: 1em;
    }
}
.ios-free-trial-btn {
    background: white;
    border-radius: 24px;
    border: 1px solid @linkButtonOrange;
    font-weight: bold;
    left: 3.3em;
    margin-bottom: 4px;
    margin-left: -8px;
    padding: 0.3em;
    position: absolute;
    top: 4.7em;
    z-index: 10;
    span {
        color: @linkButtonOrange;
        text-align: center;
        padding-top: 2px;
        padding-right: 1em;
        padding-left: 1em;
    }
}
div.free-trial-btn {
    width: fit-content;
    padding: 4px 16px 4px 4px;
    margin-left: -8px;
    margin-bottom: 4px;
    border-radius: 24px;
    font-weight: bold;
    border: 1px solid @linkButtonOrange;
    .icon {
        font-size: 25px;
        color: @linkButtonOrange;
        padding-right: 10px;
        padding-left: 10px;
        float: left;
    }
    span {
        color: @linkButtonOrange;
        padding-top: 2px;
        padding-right: 10px;
    }
}
.ios-arguments {
    margin: 0 auto;
    text-align: left;
    line-height: 14px;
    font-size: 16px;
    div {
        display: flex;
        align-items: center;
        padding: 8px 0;
        line-height: 16px;
    }
    .icon {
        font-size: 40px;
        color: @darkBlue;
        padding-right: 10px;
        float: left;
    }
}
.arguments {
    max-width: 400px;
    margin: 0 auto;
    text-align: left;
    line-height: 14px;
    font-size: 16px;
    padding-bottom: 1.5em;
    .icon {
        font-size: 40px;
        color: @darkBlue;
        padding-right: 10px;
        padding-top: 0.1em;
        float: left;
    }
}
.styleLine {
    border-right: 1px solid @black;
    width: 50vw;
    height: 50px;
    position: absolute;
    bottom: -40px;
}
.ios-bottom-tray {
    display: flex;
    justify-content: center;
    p {
        margin: 0;
    }
}
.ios-minorActions {
    color: @black;
    font-family: AndesBook;
    font-size: 15px !important;
    font-weight: bold;
    height: 10px;
    line-height: 12px;
    text-align: center;
    text-transform: uppercase;
}
.minorActions {
    width: 100%;
    font-family: AndesBook;
    text-transform: uppercase;
    font-size: 15px !important;
    color: @black;
    height: 10px;
    text-align: center;
    line-height: 12px;
}
.theme-dark {
    .minorActions, .ios-minorActions {
        color: #fff;
    }
}
.bordered-around {
    font-family: AndesBook;
    margin: 30px auto 30px;
}
.bordered {
    border: 1px solid @black;
    border-radius: 13px;
    margin: 0 20px;
    padding: 10px 20px 0;
    position: relative;
}
.bordered-inner {
    p {
        font-size: 14px;
    }
    background: white;
    .startCopy {
        font-weight: bold;
        margin-top: -0.2em;
        margin-bottom: -1em;
        background: white;
        width: fit-content;
        padding-left: 1em;
        padding-right: 1em;
    }
}
.f7-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 0;
    margin-bottom: 0;
    height: 6em;
}
.ios-f7-button {
    font-size: 17px;
    letter-spacing: -0.1px;
    margin: 10px 0;
    text-transform: none;
}
.ios-f7-block-button-container {
    margin-top: 1em;
    margin-bottom: 1em;
    text-align: center;
}
.price-string {
    margin-bottom: -0.4em;
    background: white;
    font-weight: bold;
    width: fit-content;
    padding-left: 1em;
    padding-right: 1em;
}
.theme-dark {
    .bordered-inner {
        background: black;
    }
    .startCopy {
        background: black;
    }
    .price-string{
        background: black;
    }
}
.bottom-info {
    width: fit-content;
    white-space: normal;
    text-align: center;
    display: contents;
}
@media only screen and (max-width: 360px) {
    .arguments {
        font-size: 15px;
    }
}
// iPhone SE
@media screen and (min-height: 500px) {
    .ios-Stitle {
        font-size: 24px;
    }
    .ios-f7-button {
        margin-bottom: 0.5em;
        margin-top: -1em;
    }
    .container {
        padding-bottom: 0;
        margin-bottom: 0;
    }
    .bottom-info {
        white-space: pre-wrap;
        margin-bottom: -1em;
    }
    .bordered-around {
        margin: 20px auto 20px;
    }
    .arguments {
        font-size: 15px;
    }
}
// iPhone 6/7/8
@media screen and (max-height: 720px) {
    .ios-start-free-container .block {
        padding-bottom: 0.1em;
        padding-top: 0.1em;
        margin: 0.5em 0;
    }
}
// iPhone 6/7/8+
@media screen and (max-height: 800px) {
    .ios-f7-button {
        margin-top: 1.5em;
        margin-bottom: 1.5em;
    }
    .bottom-info {
        white-space: nowrap;
        margin-bottom: 1em;
    }
}
// iPhone X+
@media screen and (min-height: 800px) {
    .ios-img {
        width: 137px;
        height: 106px;
    }
    .ios-f7-button {
        margin-top: 0;
        margin-bottom: 1.5em;
    }
}
@media screen and (min-height: 1000px) {
    .longScreenFix {
        margin-top: 20vh;
    }
}
</style>
